import createDebug from 'debug';

export default (name) => createDebug(`app:shell:${name}`);
